/* CRUX × EON — storefront learning client (gated).
 * Sends lightweight behavioural telemetry to EON and exposes a recommendations
 * fetch helper. No-op unless window.EON_STOREFRONT.enabled + .base are set
 * (theme setting "Enable EON storefront learning"). Fire-and-forget, fails open,
 * never blocks rendering. Telemetry is advisory only. */
(function () {
  'use strict';
  var C = window.EON_STOREFRONT;
  if (!C || !C.enabled || !C.base) return;

  var BASE = String(C.base).replace(/\/+$/, '');
  var SHOP = encodeURIComponent(C.shop || '');
  var ctx = C.context || {};

  function uuid() {
    try { return (crypto.randomUUID && crypto.randomUUID()) ||
      ('a' + Date.now().toString(36) + Math.random().toString(36).slice(2)); }
    catch (e) { return 'a' + Date.now().toString(36) + Math.random().toString(36).slice(2); }
  }
  function stable(store, key) {
    try { var v = store.getItem(key); if (!v) { v = uuid(); store.setItem(key, v); } return v; }
    catch (e) { return null; }
  }
  var ANON = stable(window.localStorage, 'eon_anon');
  var SESS = stable(window.sessionStorage, 'eon_sess');

  // Meta Pixel <-> EON CAPI dedup: ONE id per logical action, shared by both
  // paths (the Pixel's eventID AND EON's event_uuid). Meta collapses a Pixel hit
  // and the server-side CAPI hit only when (event_id, event_name) match — so this
  // id is NEVER random per-send on the CAPI side. fbp/fbc ride along so anonymous
  // server-side events still match. The Pixel is optional (no-op if not loaded).
  function getCookie(n) {
    try { var p = ('; ' + document.cookie).split('; ' + n + '=');
      return p.length === 2 ? p.pop().split(';').shift() : null; }
    catch (e) { return null; }
  }
  var META_EVT = { product_view: 'ViewContent', collection_view: 'ViewContent',
    search: 'Search', add_to_cart: 'AddToCart', begin_checkout: 'InitiateCheckout' };

  // ── ad click-ids ────────────────────────────────────────────
  // Capture platform click ids from the landing URL so EON's server-side CAPI
  // can attribute anonymous ad-click sessions: fbclid (Meta), ttclid (TikTok),
  // ScCid (Snap). Persisted in localStorage with capture time so follow-on
  // pageviews (no query param) still carry them; expired ids are dropped.
  function clickId(param, key, days) {
    try {
      var m = new RegExp('[?&]' + param + '=([^&#]+)', 'i').exec(location.search);
      var now = Date.now();
      if (m && m[1]) {
        var o = { v: decodeURIComponent(m[1]), t: now };
        try { window.localStorage.setItem(key, JSON.stringify(o)); } catch (e) {}
        return o;
      }
      var raw = window.localStorage.getItem(key);
      if (!raw) return null;
      var s = JSON.parse(raw);
      if (!s || !s.v || (now - (s.t || 0)) > days * 864e5) return null;
      return s;
    } catch (e) { return null; }
  }
  var FBCLID = clickId('fbclid', 'eon_fbclid', 7);    // Meta click window
  var TTCLID = clickId('ttclid', 'eon_ttclid', 30);   // TikTok Events API user.ttclid
  var SCCID  = clickId('ScCid',  'eon_sccid',  30);   // Snap CAPI click_id
  function firePixel(ev, eid) {
    try {
      if (!window.fbq || !META_EVT[ev.event_type]) return;
      var cd = { currency: 'NGN', content_type: 'product' };
      if (ev.product_shopify_id) cd.content_ids = [String(ev.product_shopify_id)];
      else if (ev.sku) cd.content_ids = [String(ev.sku)];
      if (ev.collection_handle) cd.content_category = ev.collection_handle;
      if (ev.search_query) cd.search_string = ev.search_query;
      window.fbq('track', META_EVT[ev.event_type], cd, { eventID: eid });
    } catch (e) { /* the Pixel must never block telemetry */ }
  }

  function send(ev) {
    if (!ev || !ev.event_type) return;
    var eid = uuid();
    ev.event_uuid = eid;                       // EON column; CAPI reuses this exact id
    var pl = ev.payload || {};
    pl.event_id = eid;                         // payload fallback the CAPI forwarder reads
    var fbp = getCookie('_fbp'), fbc = getCookie('_fbc');
    // No _fbc cookie (Pixel absent or blocked) but the visit came from a Meta
    // ad click: derive fbc in Meta's own cookie format, fb.1.<capture-ms>.<fbclid>,
    // using the time the click id was FIRST seen (not per-send).
    if (!fbc && FBCLID) fbc = 'fb.1.' + FBCLID.t + '.' + FBCLID.v;
    if (fbp) pl.fbp = fbp;
    if (fbc) pl.fbc = fbc;
    if (TTCLID) pl.ttclid = TTCLID.v;
    if (SCCID) pl.sc_click_id = SCCID.v;
    // Platform browser-id cookies (set by the TikTok/Snap pixels when present)
    // ride along raw — they lift server-side match quality like fbp does.
    var ttp = getCookie('_ttp');   if (ttp) pl.ttp = ttp;
    var scid = getCookie('_scid'); if (scid) pl.sc_scid = scid;
    ev.payload = pl;
    firePixel(ev, eid);                        // client Pixel with the SAME id (no-op if absent)
    var body = JSON.stringify({
      events: [ev],
      anonymous_client_id: ANON,
      session_id: SESS,
      shopify_customer_id: C.customerId || null
    });
    var url = BASE + '/api/storefront/events?shop=' + SHOP;
    try {
      // sendBeacon = no preflight, survives page unload
      if (navigator.sendBeacon && navigator.sendBeacon(url, body)) return;
    } catch (e) { /* fall through */ }
    try {
      fetch(url, { method: 'POST', body: body, keepalive: true, mode: 'cors',
        headers: { 'Content-Type': 'text/plain' } }).catch(function () {});
    } catch (e) { /* swallow */ }
  }

  // ── page-level events ──────────────────────────────────────
  if (ctx.type === 'product' && ctx.productId) {
    send({ event_type: 'product_view', product_shopify_id: ctx.productId,
           page_url: location.href });
  } else if (ctx.type === 'collection' && ctx.collection) {
    send({ event_type: 'collection_view', collection_handle: ctx.collection,
           page_url: location.href });
  } else if (ctx.type === 'search' && ctx.query) {
    send({ event_type: 'search', search_query: ctx.query, page_url: location.href });
  }

  // ── add-to-cart ────────────────────────────────────────────
  // Prefer the native theme pub/sub; fall back to product-form submit on PDP.
  try {
    if (typeof window.subscribe === 'function' && window.PUB_SUB_EVENTS &&
        window.PUB_SUB_EVENTS.cartUpdate) {
      window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, function (payload) {
        var pid = ctx.productId || null;
        try {
          var item = payload && (payload.cartData || payload.productVariantId);
          if (payload && payload.productId) pid = payload.productId;
        } catch (e) {}
        send({ event_type: 'add_to_cart', product_shopify_id: pid, page_url: location.href });
      });
    } else if (ctx.type === 'product' && ctx.productId) {
      document.addEventListener('submit', function (e) {
        var f = e.target;
        if (f && f.action && /\/cart\/add/.test(f.action)) {
          send({ event_type: 'add_to_cart', product_shopify_id: ctx.productId,
                 page_url: location.href });
        }
      }, true);
    }
  } catch (e) { /* swallow */ }

  // ── event beacon (sections can call this) ──────────────────
  // window.EON.track('eon_look_served', {product_ids:[...]}) — fire a custom
  // storefront event so EON learns from on-page behaviour (look impressions,
  // look/card clicks). Reuses send(): sendBeacon, shared anon/session ids,
  // fire-and-forget, no-op when EON is disabled (this whole IIFE returns early).
  window.EON = window.EON || {};
  window.EON.track = function (type, payload) {
    try { if (type) send({ event_type: type, payload: payload || {} }); }
    catch (e) { /* telemetry must never throw into the page */ }
  };

  // ── recommendations helper (sections can call this) ────────
  // window.EON.getRecommendations({limit, excludeProductId}) -> Promise<products[]>
  window.EON.getRecommendations = function (opts) {
    opts = opts || {};
    var q = '?shop=' + SHOP + '&anonymous_client_id=' + encodeURIComponent(ANON || '') +
            '&limit=' + (opts.limit || 12) +
            (opts.excludeProductId ? '&exclude_product_id=' + encodeURIComponent(opts.excludeProductId) : '');
    return fetch(BASE + '/api/storefront/recommendations' + q, { mode: 'cors' })
      .then(function (r) { return r.json(); })
      .then(function (j) { return (j && j.ok && j.products) ? j.products : []; })
      .catch(function () { return []; });
  };
})();
